/**
 * Mock Dashboard KPI Data
 *
 * Convention-based mock export: MOCK_GET_DASHBOARD_KPIS
 * Endpoint: getDashboardKpis (GET)
 *
 * This file contains mock KPI data for development and testing.
 * Automatically discovered and used when mock: true is set in apiRoutes.yml
 */

export const MOCK_GET_DASHBOARD_KPIS = {
  networkDeployment: {
    numberOfCorridors: 1847,
    numberOfSites: 453,
  },
  deviceIntegration: {
    numberOfSensors: 12456,
    numberOfRobots: 89,
  },
  farmgrid: {
    numberOfUsers: 2341,
    acresUnderManagement: 45892,
    farmsUnderContract: 156,
  },
  ecosystem: {
    solutionPartnersIntegrated: 34,
    solutionsInMarketplace: 287,
  },
};
